import validatorBuilder from 'validator-builder';

let configurationEmailSmtpFormValidator = null;

export default class ConfigurationEmailSmtpForm {
	constructor(data) {
		data = data || {};

		this.id = data.id || null;
		this.idSociete = data.idSociete || null;
		this.type = data.type || 0;
		this.isConfigurationPortail = data.isConfigurationPortail || false;

		// SMTP (type 0)
		this.smtpLogin = data.smtpLogin || null;
		this.smtpPassFromServeur = data.smtpPassFromServeur || false;
		this.smtpPass = this.smtpPassFromServeur ? '**********' : data.smtpPass || null;
		this.smtpServer = data.smtpServer || null;
		this.smtpPort = data.smtpPort || 0;
		this.smtpAlias = data.smtpAlias || null;
		this.smtpIsSslConnection = !data.smtpIsTlsConnection;
		this.smtpIsTlsConnection = !data.smtpIsSslConnection;

		// Microsoft (type 1)
		this.clientIdMSFromServeur = data.clientIdMSFromServeur || false;
		this.clientIdMS = this.clientIdMSFromServeur ? '**********' : data.clientIdMS || null;
		this.clientSecretMSFromServeur = data.clientSecretMSFromServeur || false;
		this.clientSecretMS = this.clientSecretMSFromServeur ? '**********' : data.clientSecretMS || null;
		this.tenantIdMSFromServeur = data.tenantIdMSFromServeur || false;
		this.tenantIdMS = this.tenantIdMSFromServeur ? '**********' : data.tenantIdMS || null;
		this.senderMail = data.senderMail || null;

		// Google (type 2)
		this.clientIdGoogleFromServeur = data.clientIdGoogleFromServeur || false;
		this.clientIdGoogle = this.clientIdGoogleFromServeur ? '**********' : data.clientIdGoogle || null;
		this.clientSecretGoogleFromServeur = data.clientSecretGoogleFromServeur || false;
		this.clientSecretGoogle = this.clientSecretGoogleFromServeur ? '**********' : data.clientSecretGoogle || null;
		this.refreshTokenGoogleFromServeur = data.refreshTokenGoogleFromServeur || false;
		this.refreshTokenGoogle = this.refreshTokenGoogleFromServeur ? '**********' : data.refreshTokenGoogle || null;
	}

	isValid() {
		configurationEmailSmtpFormValidator = configurationEmailSmtpFormValidator || validatorBuilder.getInstanceFor('ConfigurationEmailSmtpForm');

		const validationResults = configurationEmailSmtpFormValidator.validate(this);

		return validationResults.isValid;
	}
}
